import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dialog"
export default class extends Controller {
  static targets = ["form"];

  connect() {
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);

    if (this.element instanceof HTMLDialogElement) {
      if (this.element.open) {
        this.element.close();
      }
    }
  }

  disconnect() {
    this.removeDialogListeners(this.openDialogElement);
  }

  open(event) {
    event.preventDefault();
    const dialogId = event.currentTarget.getAttribute("data-dialog-id");
    const dialog = document.getElementById(dialogId);
    this.openDialog(dialog);
  }

  openDialog(dialog = this.element) {
    if (!dialog) return;

    this.removeDialogListeners(this.openDialogElement);
    this.openDialogElement = dialog;
    dialog.removeEventListener("click", this.handleOutsideClick);
    dialog.showModal();
    dialog.addEventListener("click", this.handleOutsideClick);
    dialog.addEventListener("close", this.handleDialogClose);
    this.dispatch("modal:open", {});
  }

  close() {
    const dialog =
      this.openDialogElement || (this.element instanceof HTMLDialogElement ? this.element : null);
    dialog?.close();
  }

  handleDialogClose(event) {
    this.removeDialogListeners(event.currentTarget);
    this.openDialogElement = null;
    this.dispatch("modal:close", {});
  }

  removeDialogListeners(dialog) {
    dialog?.removeEventListener("click", this.handleOutsideClick);
    dialog?.removeEventListener("close", this.handleDialogClose);
  }

  handleOutsideClick(event) {
    if (event.clientX === 0 && event.clientY === 0) {
      return;
    }

    const rect = event.currentTarget.getBoundingClientRect();
    if (
      event.clientY < rect.top ||
      event.clientY > rect.bottom ||
      event.clientX < rect.left ||
      event.clientX > rect.right
    ) {
      this.close();
    }
  }

  submitForm(event) {
    event.preventDefault();
    this.formTarget.submit();
  }

  print(event) {
    const modalId = event.target.getAttribute("data-modal-id");
    const modalContent = document.getElementById(modalId).cloneNode(true);
    let printWindow = window.open("", "_blank");
    printWindow.document.write("<html><head><title>Print Transaction</title>");
    printWindow.document.write(
      "<style>header,footer{display:none;}h2{font-size:20px;}p{margin:0;}.receipt-row>section>div{margin-bottom: 20px;}</style>",
    );
    printWindow.document.write("</head><body >");
    printWindow.document.write(modalContent.innerHTML);
    printWindow.document.write("</body></html>");
    printWindow.document.close();
    printWindow.focus();
    setTimeout(function () {
      printWindow.print();
      printWindow.close();
    }, 250);
  }
}
